import {fromJS} from 'immutable';
import * as types from 'constants/action-types';
import {
  setRecordsReducer,
  setCurrentRecordPageReducer,
  setCurrentRecordReducer,
  clearRecordsAfterPageReducer,
} from './base';

const initialState = fromJS({
  awardPages: {
    currentPage: 1,
    totalCount: 0,
    pageCount: 1,
    itemsPerPage: 0,
  },
  currentAward: {},
});

const setAwardsReducer = (state, action) => setRecordsReducer('award', state, action);

const setCurrentAwardPageReducer = (state, action) => setCurrentRecordPageReducer('award', state, action);

const setCurrentAwardReducer = (state, action) => setCurrentRecordReducer('award', state, action);

const clearAwardsAfterPageReducer = (state, action) => clearRecordsAfterPageReducer('award', state, action);

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.REINITIALIZE_STORE_STATE:
      return initialState;
    case types.SET_AWARDS:
      return setAwardsReducer(state, action);
    case types.SET_CURRENT_AWARD_PAGE:
      return setCurrentAwardPageReducer(state, action);
    case types.SET_CURRENT_AWARD:
      return setCurrentAwardReducer(state, action);
    case types.CLEAR_AWARDS_AFTER_PAGE:
      return clearAwardsAfterPageReducer(state, action);
    default:
      return state;
  }
};
